// Public - Marketing - Homepage - Homepage Marketing
// ----------------------
import React from 'react'
import {
  Segment,
  Container,
  Grid,
  Header,
  Image,
  Icon,
  List,
  Button,
  Card,
} from "semantic-ui-react";

// styles
import styles from './homepage-marketing.module.scss';
// images
import svg_devicesLockup from './images/devices-lockup.svg';
import svg_icon_apple from '../../../layouts/images/icons/icon-apple.svg';
import svg_icon_gPlay from '../../../layouts/images/icons/icon-google-play.svg';
import image_featurefollow_lockup from './images/feature-follow.png';
import image_featureoffline_lockup from './images/feature-offline.png';
import svg_stitcherLogo from './images/stitcher_logo.svg';
import image_googlePodcasts from './images/google-podcasts-logo.png'
import image_radioPublic from './images/radio-public.png'

export default function HomepageMarketing() {
  return (
    <>
      <section className={styles.component_homepage_marketing}>
        <Segment basic id={'marketing'}>
          <Segment basic className={'marketing-s1'}>
            <Container className={'main-container'}>
              <Segment basic>
                <Grid stretched stackable reversed={'mobile'} verticalAlign={'middle'} columns={'equal'}>
                  <Grid.Row>
                    <Grid.Column only='mobile' className={'second-content-column'}>
                      <Segment basic>
                        <Image fluid wrapped centered width={550} height={301} src={svg_devicesLockup} alt={'Phone, Tablet, Desktop devices and speaker'} />
                      </Segment>
                    </Grid.Column>
                    <Grid.Column className={'first-content-column'}>
                      <Segment basic>
                        <Header as='h2' textAlign={'left'}>
                          Listen to your Podcasts anywhere
                          <Header.Subheader>
                            The free iHeartRadio app is available on over 250 platforms and over 2,000 different connected devices — including smart speakers, digital auto dashes, tablets, wearables, smartphones, virtual assistants, televisions and gaming consoles.
                          </Header.Subheader>
                        </Header>
                        <List relaxed size={'large'} verticalAlign={'middle'}>
                          <List.Item>
                            <Button as={'a'} className={'app-store-download'}
                              href={'https://itunes.apple.com/us/app/iheartradio/id290638154?mt=8'}
                              target={'_blank'}
                              rel={'noreferrer'}
                              aria-label={'Download on the App Store Link'}
                            >
                              <Image wrapped width={24} height={29} src={svg_icon_apple} alt={'Apple Computer Logo'} />
                              <div>
                                <div>Download on the</div>
                                <span>App Store</span>
                              </div>
                            </Button>
                          </List.Item>
                          <List.Item>
                            <Button as={'a'} className={'app-store-download'}
                              href={'https://play.google.com/store/apps/details?id=com.clearchannel.iheartradio.controller&hl=en_US'}
                              target={'_blank'}
                              rel={'noreferrer'}
                              aria-label={'Download on the Google Play Link'}
                            >
                              <Image wrapped width={26} height={29} src={svg_icon_gPlay} alt={'Google Play Logo'} />
                              <div>
                                <div>Download on</div>
                                <span>Google Play</span>
                              </div>
                            </Button>
                          </List.Item>
                          <List.Item>
                            <Button as={'a'} icon labelPosition={'right'} className={'plain-labeled'}
                              href={'https://www.iheart.com/apps/'} 
                              target={'_blank'}
                              rel={'noreferrer'}
                              aria-label={'View All Apps Link'}
                            >
                              View All Apps
                              <Icon name='angle right' />
                            </Button>
                          </List.Item>
                        </List>
                      </Segment>
                    </Grid.Column>
                    <Grid.Column only='computer tablet' className={'second-content-column'}>
                      <Segment basic>
                        <Image fluid wrapped centered width={550} height={301} src={svg_devicesLockup} alt={'Phone, Tablet, Desktop devices and speaker'} />
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            </Container>
          </Segment>
          <Segment basic id={'learn-more'} className={'marketing-s2'}>
            <Container className={'main-container'}>
              <Segment basic>
                <Header as='h2' textAlign={'center'}>
                  Export Podcast Subscriptions from your provider
                  <Header.Subheader>
                    Switching to iHeartRadio for all your Podcast listening is easy!
                  </Header.Subheader>
                </Header>
                <Grid stretched stackable centered columns={4} verticalAlign={'middle'}>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as='h3' textAlign={'center'}>
                        Supported Platforms
                      </Header>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column textAlign={'center'} className={'first-content-column'}>
                      <Segment basic>
                        <Card fluid as={'a'} href={'https://stitcher.helpshift.com/hc/en/1-stitcher/faq/979-how-can-i-take-the-shows-i-listen-to-on-stitcher-somewhere-else/'} target={'_blank'} rel={'noreferrer'} aria-label={'How can I take the shows I listen to on Stitcher somewhere else?'} className={'stitcher'} style={{background: "url('"+svg_stitcherLogo+"') no-repeat white"}}>
                          <Card.Content>
                            <Card.Header>
                              Stitcher
                            </Card.Header>
                          </Card.Content>
                        </Card>
                      </Segment>
                    </Grid.Column>
                    <Grid.Column textAlign={'center'} className={'content-column'}>
                      <Segment basic>
                        <Card fluid as={'a'} href={'https://support.google.com/youtubemusic/answer/14151168#zippy=%2Cdownload-your-subscriptions-as-an-opml-file'} target={'_blank'} rel={'noreferrer'} aria-label={'Download your subscriptions as an OPML file'} className={'google-podcasts'} style={{background: "url('"+image_googlePodcasts+"') no-repeat white"}}>
                          <Card.Content>
                            <Card.Header>
                              Google Podcasts
                            </Card.Header>
                          </Card.Content>
                        </Card>
                      </Segment>
                    </Grid.Column>
                    <Grid.Column textAlign={'center'} className={'content-column'}>
                      <Segment basic>
                        <Card fluid as={'a'} href={'https://help.radiopublic.com/hc/en-us'} target={'_blank'} rel={'noreferrer'} aria-label={'Download your subscriptions as an OPML file'} className={'radiopublic'} style={{background: "url('"+image_radioPublic+"') no-repeat white"}}>
                          <Card.Content>
                            <Card.Header>
                              Radio Public
                            </Card.Header>
                          </Card.Content>
                        </Card>
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            </Container>
          </Segment>
          <Segment basic className={'marketing-s3'}>
            <Container className={'main-container'}>
              <Segment basic>
                <Grid stackable columns={2} verticalAlign={'middle'} stretched>
                  <Grid.Row>
                    <Grid.Column className={'first-content-column'}>
                      <Segment basic>
                        <Header as='h2' textAlign={'left'}>
                          Never miss an episode
                          <Header.Subheader>
                            Easily listen to the latest content from all your Podcasts with iHeartRadio.
                          </Header.Subheader>
                        </Header>
                        <Button as={'a'} secondary href={'https://help.iheart.com/hc/en-us/articles/115000241151-Podcasts'} target={'_blank'} rel={'noreferrer'} aria-label={'iHeartRadio Podcast Features Link'}>
                          iHeartRadio Podcast Features
                        </Button>
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
              <Image fluid wrapped width={240} height={477} src={image_featurefollow_lockup} alt={'Mobile device with screenshot of iHeartRadio App with Podcast Alert feature'} />
              <Image fluid wrapped width={240} height={477} src={image_featureoffline_lockup} alt={'Mobile device with screenshot of iHeartRadio App with Podcast Settings feature'} />
            </Container>
          </Segment>
        </Segment>
      </section>
    </>
  )
}